import React from 'react';
import { connect } from 'react-redux';
import { Field, change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import Select from 'react-select';

import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import { getGestorEmpresa } from '../../security/securityContext';
import buscarConfiguracaoEmpresa from '../../actions/empresa/buscarConfiguracaoEmpresa';
import atualizarConfiguracaoEmpresa from '../../actions/empresa/atualizarConfiguracaoEmpresa';
import buscarConfigGratuidadeTipoPreco from '../../actions/empresa/buscarConfigGratuidadeTipoPreco';
import salvarConfigGratuidadeTipoPreco from '../../actions/empresa/salvarConfigGratuidadeTipoPreco';
import listarFiltrosEmpresas from '../../actions/empresa/listarFiltrosEmpresas';
import {
    renderField,
    renderFieldNumerosPorcentagem,
    renderFieldNumber,
    required,
    tamanhoPorcentagem,
    validarIP,
    renderFieldMonetarioLabelEncima,
    maxValueMonetario,
} from '../../util/inputs';
import { tipoConfiguracaoConexaoTrecho } from '../../util/constantsUtil';

const TIPOS_PRECO_OPTIONS = [
    { value: 'EXECUTIVO', label: 'Executivo' },
    { value: 'LEITO', label: 'Leito' },
    { value: 'SEMI_LEITO', label: 'Semi Leito' },
    { value: 'CONVENCIONAL', label: 'Convencional' },
    { value: 'LEITO_ESPECIAL', label: 'Leito Cama' },
    { value: 'SEMI_LEITO_ESPECIAL', label: 'Semi Leito Especial' },
    { value: 'EXECUTIVO_ESPECIAL', label: 'Executivo Especial' },
    { value: 'EXECUTIVO_ESPECIAL_1', label: 'Executivo Especial 1' },
    { value: 'EXECUTIVO_ESPECIAL_2', label: 'Executivo Especial 2' },
    { value: 'EXECUTIVO_ESPECIAL_3', label: 'Executivo Especial 3' },
    { value: 'EXECUTIVO_ESPECIAL_4', label: 'Executivo Especial 4' },
    { value: 'EXECUTIVO_ESPECIAL_5', label: 'Executivo Especial 5' },
    { value: 'EXECUTIVO_ESPECIAL_6', label: 'Executivo Especial 6' },
    { value: 'EXECUTIVO_ESPECIAL_7', label: 'Executivo Especial 7' },
    { value: 'EXECUTIVO_ESPECIAL_8', label: 'Executivo Especial 8' },
    { value: 'EXECUTIVO_ESPECIAL_9', label: 'Executivo Especial 9' },
    { value: 'EXECUTIVO_ESPECIAL_10', label: 'Executivo Especial 10' },
    { value: 'CONVENCIONAL_ESPECIAL', label: 'Convencional Especial' },
    { value: 'CONVENCIONAL_ESPECIAL_1', label: 'Convencional Especial 1' },
    { value: 'CONVENCIONAL_ESPECIAL_2', label: 'Convencional Especial 2' },
    { value: 'CONVENCIONAL_ESPECIAL_3', label: 'Convencional Especial 3' },
    { value: 'CONVENCIONAL_ESPECIAL_4', label: 'Convencional Especial 4' },
    { value: 'CONVENCIONAL_ESPECIAL_5', label: 'Convencional Especial 5' },
    { value: 'CONVENCIONAL_ESPECIAL_6', label: 'Convencional Especial 6' },
    { value: 'CONVENCIONAL_ESPECIAL_7', label: 'Convencional Especial 7' },
    { value: 'CONVENCIONAL_ESPECIAL_8', label: 'Convencional Especial 8' },
    { value: 'CONVENCIONAL_ESPECIAL_9', label: 'Convencional Especial 9' },
    { value: 'CONVENCIONAL_ESPECIAL_10', label: 'Convencional Especial 10' },
    { value: 'LEITO_INDIVIDUAL', label: 'Leito Individual' },
    { value: 'LEITO_CAMA_INDIVIDUAL', label: 'Leito-Cama Individual' },
    { value: 'LEITO_CAMA_ESPECIAL_1', label: 'Leito Cama Especial 1' },
    { value: 'LEITO_CAMA_ESPECIAL_2', label: 'Leito Cama Especial 2' },
    { value: 'LEITO_ESPECIAL_1', label: 'Leito Especial 1' },
    { value: 'LEITO_ESPECIAL_2', label: 'Leito Especial 2' },
    { value: 'SEMI_LEITO_ESPECIAL_1', label: 'Semi Leito Especial 1' },
    { value: 'SEMI_LEITO_ESPECIAL_2', label: 'Semi Leito Especial 2' },
    { value: 'LEITO_INDIVIDUAL_ESPECIAL_1', label: 'Leito Individual Especial 1' },
    { value: 'LEITO_INDIVIDUAL_ESPECIAL_2', label: 'Leito Individual Especial 2' },
];

const TODOS_OPTION = { value: '__TODOS__', label: 'TODOS' };

const TIPOS_GRATUIDADE_CONFIG = [
    { tipoEmissao: 'IDOSO_100', label: 'ID Idoso 100%' },
    { tipoEmissao: 'ID_JOVEM_100', label: 'ID Jovem 100%' },
    { tipoEmissao: 'ID_JOVEM_50', label: 'ID Jovem 50%' },
    { tipoEmissao: 'IDOSO_50', label: 'ID Idoso 50%' },
    { tipoEmissao: 'DEFICIENTE', label: 'Deficiente' },
    { tipoEmissao: 'ACOMPANHANTE', label: 'Acompanhante' },
    { tipoEmissao: 'P_LIVRE_POLICIAL_AUDITOR', label: 'P. Livre Policial/Auditor' },
    { tipoEmissao: 'CORTESIA', label: 'Cortesia' },
];

const renderToggle = ({ input }) => (
    <label className="vx-switch" style={{ cursor: 'pointer', flexShrink: 0 }}>
        <input {...input} type="checkbox" />
        <span className="vx-switch-slider" />
    </label>
);

const SectionCard = ({ icon, title, subtitle, children }) => (
    <div className="vx-config-card">
        <div className="vx-config-card-header">
            <i className="material-icons">{icon}</i>
            <div className="vx-config-card-header-text">
                <h6>{title}</h6>
                {subtitle && <small>{subtitle}</small>}
            </div>
        </div>
        <div className="vx-config-card-body">
            {children}
        </div>
    </div>
);

export class PainelConfiguracaoEmpresa extends React.Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.handleSalvarConfigGratuidade = this.handleSalvarConfigGratuidade.bind(this);
        this.handleAdicionarPagamentoDesativado = this.handleAdicionarPagamentoDesativado.bind(this);
        this.handleRemoverPagamentoDesativado = this.handleRemoverPagamentoDesativado.bind(this);

        this._mounted = false;
        this.state = {
            mensagem: { tipo: '', texto: '' },
            configGratuidade: {},
            pagamentosDesativados: [],
        };
    }

    componentDidMount() {
        this._mounted = true;
        const { empresaSelecionada } = this.props;
        if (empresaSelecionada && empresaSelecionada.id) {
            this.props.buscarConfiguracaoEmpresa(empresaSelecionada.id);
            this.props.listarFiltrosEmpresas(empresaSelecionada.id);
            this.props.buscarConfigGratuidadeTipoPreco(empresaSelecionada.id).then(resp => {
                if (!this._mounted) return;
                if (resp && resp.payload && resp.payload.data) {
                    const mapa = {};
                    resp.payload.data.forEach(item => {
                        mapa[item.tipoEmissao] = item.tiposPrecoPermitidos || [];
                    });
                    this.setState({ configGratuidade: mapa });
                }
            });
        }
    }

    componentWillUnmount() {
        this._mounted = false;
    }

    componentDidUpdate(prevProps) {
        const curr = this.props.configuracaoEmpresa;
        const prev = prevProps.configuracaoEmpresa;
        if (curr && curr !== prev) {
            const desativados = (curr.pagamentosDesativados || []).map(chave => {
                const tp = this.props.tipoPagamentos.find(t => t.chave === chave);
                return { value: chave, label: tp ? tp.valor : chave };
            });
            this.setState({ pagamentosDesativados: desativados });
        }
    }

    handleSalvarConfigGratuidade(tipoEmissao, selectedOptions) {
        const empresaId = this.props.empresaSelecionada && this.props.empresaSelecionada.id;
        if (!empresaId) return;

        const options = selectedOptions || [];
        const contemTodos = options.some(o => o.value === '__TODOS__');
        const especificos = options.filter(o => o.value !== '__TODOS__');
        const novostipos = contemTodos ? ['TODAS'] : especificos.map(o => o.value);

        this.setState(prev => ({
            configGratuidade: { ...prev.configGratuidade, [tipoEmissao]: novostipos }
        }));
        this.props.salvarConfigGratuidadeTipoPreco(empresaId, tipoEmissao, novostipos);
    }

    handleAdicionarPagamentoDesativado(option) {
        if (!option) return;
        this.setState(prev => {
            if (prev.pagamentosDesativados.find(p => p.value === option.value)) return prev;
            return { pagamentosDesativados: [...prev.pagamentosDesativados, option] };
        });
    }

    handleRemoverPagamentoDesativado(option) {
        this.setState(prev => ({
            pagamentosDesativados: prev.pagamentosDesativados.filter(p => p.value !== option.value)
        }));
    }

    submit(values) {
        const { empresaSelecionada } = this.props;
        const cmd = {
            rntrc: values.rntrc || null,
            multaRemarcacaoDentroPrazo: values.multaRemarcacaoDentroPrazo,
            multaRemarcacaoForaPrazo: values.multaRemarcacaoForaPrazo,
            multaCancelamentoDentroPrazo: values.multaCancelamentoDentroPrazo,
            multaCancelamentoForaPrazo: values.multaCancelamentoForaPrazo,
            habilitadoBpe: values.habilitadoBpe || false,
            habilitadoBuscaPassagemHorario: values.habilitadoBuscaPassagemHorario || false,
            habilitadoCpfCnpjTitularComprovante: values.habilitadoCpfCnpjTitularComprovante || false,
            habilitadoTEF: values.habilitadoTEF || false,
            ipTEF: values.ipTEF || null,
            habilitadoPrecoFixoExcessoBagagem: values.habilitadoPrecoFixoExcessoBagagem || false,
            precoFixoExcessoBagagem: values.precoFixoExcessoBagagem ? values.precoFixoExcessoBagagem.replace('R$', '') : null,
            habilitadoRegraConexaoTrecho: values.habilitadoRegraConexaoTrecho || false,
            habilitadoVendaOffline: values.habilitadoVendaOffline || false,
            habilitadoVendaUrbana: values.habilitadoVendaUrbana || false,
            habilitadoEncomendaAvulsa: values.habilitadoEncomendaAvulsa || false,
            habilitadoComissaoEntregaEncomenda: values.habilitadoComissaoEntregaEncomenda || false,
            habilitadoCieloEcommerce: values.habilitadoCieloEcommerce || false,
            merchantIdCieloEcommerce: values.merchantIdCieloEcommerce,
            merchantKeyCieloEcommerce: values.merchantKeyCieloEcommerce,
            tempoVisualizacaoDados: values.tempoVisualizacaoDados ? parseInt(values.tempoVisualizacaoDados, 10) : null,
            pagamentosDesativados: this.state.pagamentosDesativados.map(p => p.value),
        };

        this.props.atualizarConfiguracaoEmpresa(empresaSelecionada.id, cmd)
            .then(resp => {
                if (resp.payload.status === 200) {
                    this.setState({ mensagem: { tipo: 'sucesso', texto: 'Configuração salva com sucesso' } });
                } else {
                    const texto = resp.payload.response && resp.payload.response.data &&
                        resp.payload.response.data.mensagens
                        ? resp.payload.response.data.mensagens[0].mensagem
                        : 'Erro ao salvar configuração';
                    this.setState({ mensagem: { tipo: 'erro', texto } });
                }
            })
            .catch(error => {
                const texto = error.response && error.response.data && error.response.data.mensagens
                    ? error.response.data.mensagens[0].mensagem
                    : 'Erro ao salvar configuração';
                this.setState({ mensagem: { tipo: 'erro', texto } });
            });
    }

    recuperaMensagem() {
        const { mensagem } = this.state;
        if (!mensagem || !mensagem.tipo) return null;
        const isSucesso = mensagem.tipo === 'sucesso';
        return (
            <div className={`vx-config-alert vx-config-alert--${mensagem.tipo}`}>
                <i className="material-icons">{isSucesso ? 'check_circle' : 'error_outline'}</i>
                <span>{mensagem.texto}</span>
                <button type="button" onClick={() => this.setState({ mensagem: { tipo: '', texto: '' } })}>
                    <i className="material-icons" style={{ fontSize: 18 }}>close</i>
                </button>
            </div>
        );
    }

    exibirDadosCadastrais() {
        const config = this.props.configuracaoEmpresa || {};
        const telefones = config.telefones && config.telefones.length
            ? config.telefones.join(', ')
            : '-';
        const items = [
            { icon: 'badge', label: 'CNPJ/CPF', value: config.cnpj || '-' },
            { icon: 'business_center', label: 'Razão Social', value: config.nome || '-' },
            { icon: 'store', label: 'Nome Fantasia', value: config.nomeFantasia || '-' },
            { icon: 'phone', label: 'Telefone', value: telefones },
            { icon: 'email', label: 'E-mail', value: config.email || '-' },
        ];
        return (
            <div className="vx-info-grid">
                {items.map(({ icon, label, value }) => (
                    <div key={label} className="vx-info-item">
                        <div className="vx-info-item-label">
                            <i className="material-icons" style={{ fontSize: 11, verticalAlign: 'middle', marginRight: 3 }}>{icon}</i>
                            {label}
                        </div>
                        <div className="vx-info-item-value" title={value}>{value}</div>
                    </div>
                ))}
            </div>
        );
    }

    exibirHabilitacoes() {
        const { habilitadoTEF, habilitadoPrecoFixoExcessoBagagem, habilitadoCieloEcommerce } = this.props;
        return (
            <div>
                <div className="vx-toggle-row">
                    <div className="vx-toggle-info">
                        <div className="vx-toggle-info-title">Emissão de BPe</div>
                        <div className="vx-toggle-info-desc">Habilita a emissão de Bilhete de Passagem Eletrônico</div>
                    </div>
                    <Field name="habilitadoBpe" type="checkbox" component={renderToggle} />
                </div>

                <div className="vx-toggle-row">
                    <div className="vx-toggle-info">
                        <div className="vx-toggle-info-title">Busca por Horário</div>
                        <div className="vx-toggle-info-desc">Permite buscar passagens filtrando por horário específico</div>
                    </div>
                    <Field name="habilitadoBuscaPassagemHorario" type="checkbox" component={renderToggle} />
                </div>

                <div className="vx-toggle-row">
                    <div className="vx-toggle-info">
                        <div className="vx-toggle-info-title">CPF/CNPJ no Comprovante</div>
                        <div className="vx-toggle-info-desc">Exige CPF/CNPJ do titular no fechamento de caixa</div>
                    </div>
                    <Field name="habilitadoCpfCnpjTitularComprovante" type="checkbox" component={renderToggle} />
                </div>

                <div className="vx-toggle-row">
                    <div className="vx-toggle-info">
                        <div className="vx-toggle-info-title">Venda via TEF</div>
                        <div className="vx-toggle-info-desc">Habilita o terminal de pagamento eletrônico (TEF)</div>
                        {habilitadoTEF && (
                            <div className="vx-toggle-sub">
                                <Field name="ipTEF" type="text"
                                    component={renderField}
                                    label="IP do Servidor TEF"
                                    validate={[required, validarIP]}
                                    css="form-control"
                                />
                            </div>
                        )}
                    </div>
                    <Field name="habilitadoTEF" type="checkbox" component={renderToggle} />
                </div>

                <div className="vx-toggle-row">
                    <div className="vx-toggle-info">
                        <div className="vx-toggle-info-title">Venda Offline</div>
                        <div className="vx-toggle-info-desc">Permite que operadores realizem vendas sem conexão com a internet</div>
                    </div>
                    <Field name="habilitadoVendaOffline" type="checkbox" component={renderToggle} />
                </div>

                <div className="vx-toggle-row">
                    <div className="vx-toggle-info">
                        <div className="vx-toggle-info-title">Vendas Urbanas</div>
                        <div className="vx-toggle-info-desc">Permite a venda avulsa dentro da cidade, vinculada a um itinerário aberto, sem seleção de poltrona</div>
                    </div>
                    <Field name="habilitadoVendaUrbana" type="checkbox" component={renderToggle} />
                </div>

                <div className="vx-toggle-row">
                    <div className="vx-toggle-info">
                        <div className="vx-toggle-info-title">Encomenda Avulsa</div>
                        <div className="vx-toggle-info-desc">Permite a venda de encomendas avulsas vinculadas a um itinerário aberto, com impressão de vias e etiquetas por volume</div>
                    </div>
                    <Field name="habilitadoEncomendaAvulsa" type="checkbox" component={renderToggle} />
                </div>

                <div className="vx-toggle-row">
                    <div className="vx-toggle-info">
                        <div className="vx-toggle-info-title">Comissão de Entrega de Encomenda</div>
                        <div className="vx-toggle-info-desc">Permite comissionar o usuário responsável por finalizar a entrega de uma encomenda</div>
                    </div>
                    <Field name="habilitadoComissaoEntregaEncomenda" type="checkbox" component={renderToggle} />
                </div>

                <div className="vx-toggle-row">
                    <div className="vx-toggle-info">
                        <div className="vx-toggle-info-title">Preço Fixo – Excesso de Bagagem</div>
                        <div className="vx-toggle-info-desc">Define um valor fixo para cobrança de excesso de bagagem</div>
                        {habilitadoPrecoFixoExcessoBagagem && (
                            <div className="vx-toggle-sub">
                                <Field name="precoFixoExcessoBagagem"
                                    validate={[maxValueMonetario, required]}
                                    component={renderFieldMonetarioLabelEncima}
                                    label="Preço fixo Excesso Bagagem:"
                                    css="form-control"
                                />
                            </div>
                        )}
                    </div>
                    <Field name="habilitadoPrecoFixoExcessoBagagem" type="checkbox" component={renderToggle} />
                </div>

                <div className="vx-toggle-row">
                    <div className="vx-toggle-info">
                        <div className="vx-toggle-info-title">Cielo E-commerce (PIX)</div>
                        <div className="vx-toggle-info-desc">Habilita venda de passagem via PIX usando a conta Cielo E-commerce desta empresa</div>
                        {habilitadoCieloEcommerce && (
                            <div className="vx-toggle-sub">
                                <Field name="merchantIdCieloEcommerce" type="text"
                                    component={renderField}
                                    label="Merchant ID Cielo E-commerce"
                                    validate={[required]}
                                    css="form-control"
                                />
                                <Field name="merchantKeyCieloEcommerce" type="password"
                                    component={renderField}
                                    label="Merchant Key Cielo E-commerce"
                                    validate={[required]}
                                    css="form-control"
                                />
                            </div>
                        )}
                    </div>
                    <Field name="habilitadoCieloEcommerce" type="checkbox" component={renderToggle} />
                </div>
            </div>
        );
    }

    exibirConexaoTrecho() {
        const { habilitadoRegraConexaoTrecho } = this.props;
        const opcoes = [
            {
                id: 'atual',
                valor: true,
                label: tipoConfiguracaoConexaoTrecho.regraAtual.valor,
                desc: 'Regra atual de conexão entre trechos',
            },
            {
                id: 'antiga',
                valor: false,
                label: tipoConfiguracaoConexaoTrecho.regraAntiga.valor,
                desc: 'Regra legada de conexão entre trechos',
            },
        ];
        return (
            <div className="vx-radio-cards">
                {opcoes.map(({ id, valor, label, desc }) => {
                    const selected = valor === true
                        ? habilitadoRegraConexaoTrecho === true
                        : habilitadoRegraConexaoTrecho !== true;
                    return (
                        <div
                            key={id}
                            className={`vx-radio-card${selected ? ' vx-radio-card--selected' : ''}`}
                            onClick={() => this.props.changeFieldValue('formularioConfiguracaoEmpresa', 'habilitadoRegraConexaoTrecho', valor)}
                        >
                            <div className="vx-radio-card-title">
                                <i className="material-icons" style={{ fontSize: 15, verticalAlign: 'middle', marginRight: 5, color: selected ? 'var(--vx-primary)' : '#ccc' }}>
                                    {selected ? 'radio_button_checked' : 'radio_button_unchecked'}
                                </i>
                                {label}
                            </div>
                            <div className="vx-radio-card-desc">{desc}</div>
                        </div>
                    );
                })}
            </div>
        );
    }

    exibirGratuidades() {
        return (
            <div>
                <p className="vx-config-gratuidade-hint">
                    Selecione os tipos de serviço permitidos para cada gratuidade. Selecione <strong>TODOS</strong> para liberar em todas as categorias, ou deixe vazio para bloquear. As alterações são salvas automaticamente.
                </p>
                {TIPOS_GRATUIDADE_CONFIG.map(({ tipoEmissao, label }) => {
                    const tiposPermitidos = this.state.configGratuidade[tipoEmissao] || [];
                    const ativo = tiposPermitidos.length > 0;
                    const selectedOptions = tiposPermitidos.includes('TODAS')
                        ? [TODOS_OPTION]
                        : TIPOS_PRECO_OPTIONS.filter(o => tiposPermitidos.includes(o.value));
                    return (
                        <div key={tipoEmissao} className="vx-gratuidade-row">
                            <span className="vx-gratuidade-badge">
                                <i className="material-icons" style={{ fontSize: 13, verticalAlign: 'middle', marginRight: 4, color: ativo ? '#28a745' : '#bbb' }}>
                                    {ativo ? 'check_circle' : 'block'}
                                </i>
                                {label}
                            </span>
                            <div style={{ flex: 1 }}>
                                <Select
                                    isMulti
                                    isClearable
                                    placeholder="Bloqueado (nenhum tipo habilitado)..."
                                    noOptionsMessage={() => 'Nenhuma opção encontrada'}
                                    options={[TODOS_OPTION, ...TIPOS_PRECO_OPTIONS]}
                                    value={selectedOptions}
                                    onChange={selected => this.handleSalvarConfigGratuidade(tipoEmissao, selected)}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        control: base => ({ ...base, fontSize: 12, minHeight: 34 }),
                                        multiValue: base => ({ ...base, background: 'rgba(255,106,0,0.12)', borderRadius: 4 }),
                                        multiValueLabel: base => ({ ...base, color: '#c94400', fontWeight: 600 }),
                                        multiValueRemove: base => ({ ...base, color: '#c94400', ':hover': { background: 'rgba(255,106,0,0.2)', color: '#c94400' } }),
                                    }}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    exibirPagamentosDesativados() {
        const { tipoPagamentos } = this.props;
        const { pagamentosDesativados } = this.state;
        const opcoesDisponiveis = (tipoPagamentos || [])
            .filter(tp => !pagamentosDesativados.find(p => p.value === tp.chave))
            .map(tp => ({ value: tp.chave, label: tp.valor }));

        return (
            <div>
                <Select
                    placeholder="Adicionar forma de pagamento para desativar..."
                    styles={{
                        control: base => ({ ...base, fontSize: 13, borderColor: '#e4e7ea', cursor: 'pointer' }),
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    noOptionsMessage={() => 'Nenhuma opção disponível'}
                    options={opcoesDisponiveis}
                    value={null}
                    onChange={e => this.handleAdicionarPagamentoDesativado(e)}
                />
                <div className="vx-payment-tags">
                    {pagamentosDesativados.length === 0
                        ? <span className="vx-payment-empty">Todos os meios de pagamento estão ativos</span>
                        : pagamentosDesativados.map(p => (
                            <span key={`pd_${p.value}`} className="vx-payment-tag">
                                {p.label}
                                <button type="button" onClick={() => this.handleRemoverPagamentoDesativado(p)} title="Remover">
                                    <i className="material-icons" style={{ fontSize: 14 }}>close</i>
                                </button>
                            </span>
                        ))
                    }
                </div>
            </div>
        );
    }

    render() {
        const { handleSubmit, submitting, invalid, empresaSelecionada } = this.props;
        return (
            <Autorizacao perfisPermitidos={[getGestorEmpresa(empresaSelecionada && empresaSelecionada.id)]}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Configuração da Empresa" urlRetorno="/gestao-empresa" />                        
                        <div className="col-12 conteudo-internas conteudo-painel">
                            <form onSubmit={handleSubmit(this.submit)} className="vx-config-page">

                                <SectionCard icon="business" title="Dados Cadastrais" subtitle="Informações de registro da empresa (somente leitura)">
                                    {this.exibirDadosCadastrais()}
                                </SectionCard>

                                <SectionCard icon="local_shipping" title="RNTRC" subtitle="Registro Nacional de Transportadores Rodoviários de Carga">
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                        <i className="material-icons" style={{ color: 'var(--vx-primary)', fontSize: 42, flexShrink: 0 }}>local_shipping</i>
                                        <div style={{ flex: 1 }}>
                                            <Field name="rntrc" type="text" component={renderField}
                                                label="RNTRC:" css="form-control" readOnly={false} />
                                        </div>
                                    </div>
                                </SectionCard>

                                <div className="vx-config-grid">
                                    <SectionCard icon="gavel" title="Políticas de Multa" subtitle="Percentuais de remarcação e cancelamento">
                                        <div className="vx-multa-grid">
                                            <div className="vx-multa-item">
                                                <Field name="multaRemarcacaoDentroPrazo" validate={[required, tamanhoPorcentagem]}
                                                    component={renderFieldNumerosPorcentagem}
                                                    css="form-control" label="Remarcação dentro do prazo (%)" />
                                            </div>
                                            <div className="vx-multa-item">
                                                <Field name="multaRemarcacaoForaPrazo" validate={[required, tamanhoPorcentagem]}
                                                    component={renderFieldNumerosPorcentagem}
                                                    css="form-control" label="Remarcação fora do prazo (%)" />
                                            </div>
                                            <div className="vx-multa-item">
                                                <Field name="multaCancelamentoDentroPrazo" validate={[required, tamanhoPorcentagem]}
                                                    component={renderFieldNumerosPorcentagem}
                                                    css="form-control" label="Cancelamento dentro do prazo (%)" />
                                            </div>
                                            <div className="vx-multa-item">
                                                <Field name="multaCancelamentoForaPrazo" validate={[required, tamanhoPorcentagem]}
                                                    component={renderFieldNumerosPorcentagem}
                                                    css="form-control" label="Cancelamento fora do prazo (%)" />
                                            </div>
                                        </div>
                                    </SectionCard>

                                    <SectionCard icon="device_hub" title="Conexão de Trecho" subtitle="Regra de vínculo entre trechos de viagem">
                                        {this.exibirConexaoTrecho()}
                                    </SectionCard>
                                </div>

                                <SectionCard icon="toggle_on" title="Habilitações" subtitle="Funcionalidades ativas para esta empresa">
                                    {this.exibirHabilitacoes()}
                                </SectionCard>

                                <div className="vx-config-grid">
                                    <SectionCard icon="money_off" title="Pagamentos Desativados" subtitle="Formas de pagamento bloqueadas nesta empresa">
                                        {this.exibirPagamentosDesativados()}
                                    </SectionCard>

                                    <SectionCard icon="access_time" title="Visualização de Dados" subtitle="Período máximo de acesso a dados históricos">
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                            <i className="material-icons" style={{ color: 'var(--vx-primary)', fontSize: 42, flexShrink: 0 }}>date_range</i>
                                            <div style={{ flex: 1 }}>
                                                <Field name="tempoVisualizacaoDados" type="text"
                                                    component={renderFieldNumber}
                                                    formatacao="##"
                                                    label="Tempo de visualização de dados (em Dias):"
                                                    css="form-control" readOnly={false} />
                                            </div>
                                        </div>
                                    </SectionCard>
                                </div>

                                <SectionCard icon="card_giftcard" title="Gratuidades por Tipo de Serviço" subtitle="Categorias de passagem habilitadas para cada benefício">
                                    {this.exibirGratuidades()}
                                </SectionCard>

                                <div className="vx-config-save-bar">
                                    <span className="vx-config-save-hint">
                                        <i className="material-icons">info_outline</i>
                                        Gratuidades são salvas automaticamente ao alterar
                                    </span>
                                    <button
                                        type="submit"
                                        disabled={invalid || submitting}
                                        className="btn btn-laranja vx-config-save-btn"
                                    >
                                        <i className="material-icons">save</i>
                                        Salvar Configurações
                                    </button>
                                </div>

                            </form>
                            {this.recuperaMensagem()}
                        </div>
                    </div>
                </div>
            </Autorizacao>
        );
    }
}

const selector = formValueSelector('formularioConfiguracaoEmpresa');

function mapStateToProps(state) {
    const config = state.configuracaoEmpresa || {};
    return {
        empresaSelecionada: state.empresaSelecionada,
        configuracaoEmpresa: state.configuracaoEmpresa,
        tipoPagamentos: (state.filtrosEmpresas && state.filtrosEmpresas.tipoPagamentos) || [],
        habilitadoTEF: selector(state, 'habilitadoTEF'),
        habilitadoPrecoFixoExcessoBagagem: selector(state, 'habilitadoPrecoFixoExcessoBagagem'),
        habilitadoRegraConexaoTrecho: selector(state, 'habilitadoRegraConexaoTrecho'),
        habilitadoCieloEcommerce: selector(state, 'habilitadoCieloEcommerce'),
        initialValues: {
            rntrc: config.rntrc,
            multaRemarcacaoDentroPrazo: config.multaRemarcacaoDentroPrazo,
            multaRemarcacaoForaPrazo: config.multaRemarcacaoForaPrazo,
            multaCancelamentoDentroPrazo: config.multaCancelamentoDentroPrazo,
            multaCancelamentoForaPrazo: config.multaCancelamentoForaPrazo,
            habilitadoBpe: config.habilitadoBpe,
            habilitadoBuscaPassagemHorario: config.habilitadoBuscaPassagemHorario,
            habilitadoCpfCnpjTitularComprovante: config.habilitadoCpfCnpjTitularComprovante,
            habilitadoTEF: config.habilitadoTEF,
            ipTEF: config.ipTEF,
            habilitadoPrecoFixoExcessoBagagem: config.habilitadoPrecoFixoExcessoBagagem,
            precoFixoExcessoBagagem: config.precoFixoExcessoBagagem,
            habilitadoRegraConexaoTrecho: config.habilitadoRegraConexaoTrecho,
            tempoVisualizacaoDados: config.tempoVisualizacaoDados,
            habilitadoVendaOffline: config.habilitadoVendaOffline,
            habilitadoVendaUrbana: config.habilitadoVendaUrbana,
            habilitadoEncomendaAvulsa: config.habilitadoEncomendaAvulsa,
            habilitadoComissaoEntregaEncomenda: config.habilitadoComissaoEntregaEncomenda,
            habilitadoCieloEcommerce: config.habilitadoCieloEcommerce,
            merchantIdCieloEcommerce: config.merchantIdCieloEcommerce,
            merchantKeyCieloEcommerce: config.merchantKeyCieloEcommerce,
        },
    };
}

const mapDispatchToProps = dispatch => bindActionCreators({
    changeFieldValue,
    buscarConfiguracaoEmpresa,
    atualizarConfiguracaoEmpresa,
    buscarConfigGratuidadeTipoPreco,
    salvarConfigGratuidadeTipoPreco,
    listarFiltrosEmpresas,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioConfiguracaoEmpresa',
    enableReinitialize: true,
})(PainelConfiguracaoEmpresa));
